import PrivacyContainer from "./containers/PrivacyContainer";
import "./styles.scss";

export default PrivacyContainer;
